import axios from "axios";
import {
  API_URL,
  token_string,
  headers,
  API_TOKEN_PREFIX,
  CSRF_COOKIE_PREFIX,
  CSRF_HEADER_PREFIX,
} from "../constants/config";
import { readCookie, removeCookie } from "./cookie";

function init() {
  var csrf_token = readCookie(token_string)
    ? readCookie(token_string).replace(API_TOKEN_PREFIX, CSRF_COOKIE_PREFIX)
    : "";
  var csrf_header = readCookie(token_string)
    ? readCookie(token_string).replace(API_TOKEN_PREFIX, CSRF_HEADER_PREFIX)
    : "";
  // var csrf_api = readCookie(token_string)?readCookie(token_string).replace('IDPAT', 'IDPCT'):'';
  // var csrf_value = readCookie(csrf_token);
  // console.log('doc cookie',document.cookie);
  const options = {
    baseURL: API_URL,
    withCredentials: true,
    // xsrfHeaderName: csrf_header,
    // xsrfCookieName: csrf_token,
    headers: headers,
    // {
    //   Accept: 'application/json',
    //   'Content-Type': 'application/json',
    //   // csrf_header: csrf_value,
    // },
  };

  // var headers;
  // if (readCookie(csrf_token)) {
  //     options.headers[csrf_header] = readCookie(csrf_token);
  //     console.log('options.headers',options.headers);
  // }
  // let token;

  // try {
  //   token = readCookie(readCookie(token_string));
  // } catch (e) {
  //   // console.log('asdadas das das d as d sdxxx');
  //   // console.log(e,'xxx');
  // }

  // if (token) {
  //   options.headers['Authorization'] = `Bearer ${token}`;
  // }

  var instance = axios.create(options);

  // Add a request interceptor
  instance.interceptors.request.use(
    function (config) {
      csrf_token = readCookie(token_string)
        ? readCookie(token_string).replace(API_TOKEN_PREFIX, CSRF_COOKIE_PREFIX)
        : "";
      csrf_header = readCookie(token_string)
        ? readCookie(token_string).replace(API_TOKEN_PREFIX, CSRF_HEADER_PREFIX)
        : "";
      // // Do something before request is sent
      // console.log('axios', config);
      // return config;
      let token, crsf;

      try {
        token = readCookie(readCookie(token_string));
        crsf = readCookie(csrf_token);
        // console.groupCollapsed('csrf debug');
        // console.log(crsf, csrf_token, readCookie(token_string));
        // console.log(readCookie(readCookie(token_string)));
        // // console.log(document.cookie);
        // console.groupEnd();
      } catch (e) {
        // console.log('asdadas das das d as d sdxxx');
        // console.log(e,'xxx');
      }
      // Do something before request is sent
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
        // console.log(config.headers,'xxx');
      }
      if (crsf) {
        config.headers[csrf_header] = crsf;
      }
      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  const redirectOnAuthFail = (response) => {
    if (
      !response ||
      (response &&
        (response.status === 401 ||
          response.status === 0 ||
          (response.data && parseInt(response.data.status_code, 10) === 401)))
    ) {
      // window.location.assign(API_URL);
    }
  };

  instance.interceptors.response.use(
    function (response) {
      // console.log('axios response headers', response);
      redirectOnAuthFail(response);
      return response;
    },
    function (error) {
      // const dispatch = useDispatch();
      // console.log(error.response,'[aaa');
      // dispatch(setnotifyData({ show:true, type: 'error', text: "Server Error" }));
      // removeCookie(readCookie(readCookie(token_string)));
      // removeCookie(readCookie(token_string));
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      redirectOnAuthFail(error.response);
      return Promise.reject(error);
    }
  );
  return instance;
}

export default init();
